import { gql, useMutation } from '@apollo/client';

export const UPLOAD_COMPANY_LOGO = gql`
  mutation UploadCompanyLogo($file: Upload!, $size: Int!, $variant: LogoVariant!) {
    uploadCompanyLogo(file: $file, size: $size, variant: $variant) {
      id
      logoUrl
      lightLogoUrl
    }
  }
`;

export interface WhitelabelConfigLogoUploadResultType {
  id: string;
  logoUrl: string;
  lightLogoUrl: string;
}

export interface UploadCompanyLogoInput {
  file: File;
  size: number;
  variant: 'DEFAULT' | 'LIGHT' | 'AVATAR';
}

export interface UploadCompanyLogoResult {
  uploadCompanyLogo: WhitelabelConfigLogoUploadResultType;
}

export function useWhitelabelConfigLogoUploadMutation() {
  return useMutation<UploadCompanyLogoResult, UploadCompanyLogoInput>(UPLOAD_COMPANY_LOGO, {
    refetchQueries: ['GetCompany'],
    context: {
      headers: {
        'apollo-require-preflight': true,
      },
    },
  });
}
